import React from "react"
import styles from "./menu-model.module.css"
/**
 * @returns {{columns: import('@syncfusion/ej2-filemanager').ColumnModel[]}}
 * @param {{t: import('i18next').TFunction, sortComparer: (a: any, b: any) => number}}
 */
export const OriginalMenuModel = ({ t, sortComparer }) => ({
  columns: [
    {
      field: 'name',
      headerText: t('fileManager.listView.header.name'),
      width: 250,
    },
    {
      field: 'shared',
      headerText: t('fileManager.listView.header.shared'),
      width: 150,
      template: (data) => {

        const v = data && data.shared
        return v
          ?
          <>
            <div className={styles.isShared}>
              <img width={11} height={12} src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL_ICONS}${process.env.REACT_APP_ICONS_FILE_SHARED_ICON}`} alt="shared icon"
              />
              <span>{t('fileManager.listView.content.shared')}</span>
            </div>
          </>
          : <span>{t('fileManager.listView.content.private')}</span>
      }
    },
    {
      field: 'dateModified',
      headerText: t('fileManager.listView.header.startDate'),
      sortComparer: sortComparer,
      width: 180,
    },
    {
      field: 'size',
      headerText: t('fileManager.listView.header.size'),
      width: 120,
    },
    {
      field: 'expirationDate',
      headerText: t('fileManager.listView.header.expirationDate'),
      width: 180,
    },
    {
      field: 'statusIA',
      headerText: t('fileManager.listView.header.status.ia'),
      width: 180,
    },
  ],
})